import React, { useState, useEffect } from 'react'
import ButtonField from '../UI/Button/ButtonModalField';
import { Modal } from 'react-bootstrap';
import { FetchAPI } from '../../api/fetch';
import { useTranslation } from 'react-i18next';
import Tree from 'react-tree-graph';
import { easeElastic } from 'd3-ease';
import 'react-tree-graph/dist/style.css'
import './ModalTreeBox.css'
import BeatLoader from "react-spinners/BeatLoader";
import 'assets/css/custom.css';


const ModalBox = ( props ) => {
    const { t, i18n } = useTranslation();
    let data = {
        name: 'Parent',
        children: [{
            name: 'Child One',
            children: [{
                name: 'Children Child 1'
            },
            {
                name:'Children Child 2'
            },
            {
                name:'Children Child 3'
            },
            {
                name:'Children Child 4'
            }]
        }, {
            name: 'Child Two',
            children: [{
                name: 'Children Child Two 1'
            },
            {
                name:'Children Child Two 2'
            },
            {
                name:'Children Child Two 3'
            },
            {
                name:'Children Child Two 4'
            }]
        }, {
            name: 'Child Three',
            children: [{
                name: 'Children Child Three 1'
            },
            {
                name:'Children Child Three 2'
            },
            {
                name:'Children Child Three 3'
            }]
        }, {
            name: 'Child Four',
            children: [{
                name: 'Children Child Four 1'
            },
            {
                name:'Children Child Four 2'
            },
            {
                name:'Children Child Four 3'
            },
            {
                name:'Children Child Four 4'
            }]
        }, {
            name: 'Child Five'
        }]
    };
    let [treedata, setTreedata] = useState(data);
    let [loadData, setloadData] = useState(true);

    useEffect(() => {
        (async () => {
            setloadData(false);
            const getresponse = await FetchAPI(props.getURL);
            const getresponseJson = await getresponse.json();
            const responseData = getresponseJson.data;
            setTimeout(() => {
                setTreedata(responseData);
                setloadData(true);
            }, 1000);
        })()
    }, [])

    
    return (
        <div>
            <form>
                <Modal key="ModalK"
                    show={props.showModal}
                    onHide={props.hide}
                    className="modal-custom"
                    dialogClassName={props.treeModalWidth}>
                        <span className="close-icon-custom" onClick={props.hide}>
                            &times;
                        </span>
                    <Modal.Header  key="MHeader" className="modal-header-custom" >
                        <Modal.Title key="MTitle"> {props.titlePreFix}&nbsp;{props.title}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body key="MBody" >
                        <div className="custom-container">
                            {loadData ?
                                <Tree
                                    nodeRadius={2}
                                    lineHeight={props.treeLineHeight}
                                    data={treedata}
                                    height={(treedata.hasOwnProperty('children') && treedata.children.hasOwnProperty('children') ? (Object.keys(treedata.children.children).length * 100) :
                                        treedata.hasOwnProperty('children') ?
                                            (Object.keys(treedata.children).length * 100) : 100)}
                                    width={props.treeWidth}
                                    animated
                                    easing={easeElastic}
                                    svgProps={{
                                        className: 'custom'
                                    }}
                                />
                                :
                                <div style={{ textAlign: 'center', marginTop: '20px' }}>
                                    <BeatLoader />
                                </div>
                            }
                        </div>
                    </Modal.Body>
                    <Modal.Footer key="MFooter">
                        <div className='text-center mb-3 row'>
                            <ButtonField submit={props.hide} color="info" BName={t('close')} />
                        </div>
                    </Modal.Footer>
                </Modal>
            </form>
        </div>
        
    );
}

export default ModalBox;